const { trackMetric } = require('../collector');
const { supportsEnvironment, supportsMatchMediaApi } = require('../support');
const {
  D2ID, DARK_MODE, REDUCED_MOTION, REDUCED_COLOR, URL,
} = require('../../constants/metrics');

const D2ID_REGEXP = /(?:_d2id=)([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/;
function extractD2id(cookies) {
  if (!cookies) {
    return null;
  }
  const match = cookies.match(D2ID_REGEXP);
  return match ? match[1] : match;
}

const browserInformationMonitor = () => {
  const d2id = extractD2id(typeof document !== 'undefined' && document.cookie);
  if (d2id) {
    trackMetric(D2ID, `${d2id}`);
  }
  if (supportsEnvironment()) {
    trackMetric(URL, `${window.location.origin}${window.location.pathname}`);
  }
  if (supportsMatchMediaApi()) {
    trackMetric(DARK_MODE, window.matchMedia('(prefers-color-scheme: dark)').matches);

    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;
    trackMetric(REDUCED_MOTION, isReduced);

    // https://github.com/w3c/csswg-drafts/issues/6036
    // eslint-disable-next-line max-len
    const contrastPrefers = window.matchMedia('(prefers-contrast: custom), (prefers-contrast: less), (prefers-contrast: more)').matches === true
      || window.matchMedia('(forced-colors: active)').matches === true;
    trackMetric(REDUCED_COLOR, contrastPrefers);
  }
};

module.exports = browserInformationMonitor;
